/* eslint-disable react/no-array-index-key */
import { FC, Fragment } from 'react';
import { Tooltip } from 'react-tooltip';

export type DetailsProfileBadge = {
  text: string;
  className: string;
  tooltip?: any;
};

type DetailsProfileSectionProps = {
  name: string;
  image?: string;
  position?: string;
  badges?: DetailsProfileBadge[];
  description: string;
};

const DetailsProfileSection: FC<DetailsProfileSectionProps> = ({
  name,
  image,
  badges,
  position,
  description,
}) => (
  <div className="card-inner">
    <div className="user-card user-card-s2">
      <div className="user-avatar lg bg-primary">
        {image ? (
          <img src={image} alt="Logo" />
        ) : (
          <span>{name?.slice(0, 2).toUpperCase()}</span>
        )}
      </div>

      <div className="user-info">
        <h5>{name}</h5>

        {position && (
          <div className="badge badge-outline badge-pill text-primary ucap">
            {position}
          </div>
        )}

        {badges?.map((badge, index) => (
          <Fragment key={`partner-details-profile-badge-${index}`}>
            <div
              className={`badge badge-outline badge-pill text-primary ucap mx-1 ${
                badge.className
              } ${badge.tooltip ? 'cursor-help' : 'cursor-not-allowed'}`}
              data-tooltip-id={`partner-details-profile-badge-${index}`}
            >
              {badge.text}
            </div>

            {badge.tooltip && (
              <Tooltip
                id={`partner-details-profile-badge-${index}`}
                place="bottom"
                style={{ zIndex: 9999, maxWidth: 400 }}
              >
                {badge.tooltip}
              </Tooltip>
            )}
          </Fragment>
        ))}

        <span className="sub-text">{description}</span>
      </div>
    </div>
  </div>
);

export default DetailsProfileSection;
